import type { Template } from "@/types";

export const PO_05_H0_V5: Template[] = [
    {
        id: "po-05-h0v5-01",
        name: "PO 01 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 94, y: 283, width: 231, height: 350, rotation: 0, imageRotation: 0 },
            { id: "2", x: 333, y: 283, width: 231, height: 350, rotation: 0, imageRotation: 0 },
            { id: "3", x: 572, y: 283, width: 231, height: 350, rotation: 0, imageRotation: 0 },
            { id: "4", x: 811, y: 283, width: 231, height: 350, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1050, y: 283, width: 230, height: 350, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-02",
        name: "PO 02 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 258, width: 269, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 277, y: 258, width: 269, height: 401, rotation: 0, imageRotation: 0 },
            { id: "3", x: 554, y: 258, width: 268, height: 401, rotation: 0, imageRotation: 0 },
            { id: "4", x: 830, y: 258, width: 268, height: 401, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1106, y: 258, width: 268, height: 401, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-03",
        name: "PO 03 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 136, y: 304, width: 204, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 304, width: 204, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 718, y: 304, width: 203, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 929, y: 304, width: 203, height: 309, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1140, y: 304, width: 203, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },
 

    {
        id: "po-05-h0v5-04",
        name: "PO 04 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 63, y: 178, width: 375, height: 560, rotation: 0, imageRotation: 0 },
            { id: "2", x: 446, y: 178, width: 185, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 446, y: 462, width: 185, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 737, y: 241, width: 289, height: 434, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1034, y: 241, width: 289, height: 434, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-05",
        name: "PO 05 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 91, y: 178, width: 387, height: 560, rotation: 0, imageRotation: 0 },
            { id: "2", x: 485, y: 178, width: 126, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 485, y: 368, width: 126, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 485, y: 557, width: 126, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 843, y: 178, width: 376, height: 560, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h0v5-06",
        name: "Hr 06 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 106, y: 102, width: 474, height: 712, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 102, width: 233, height: 352, rotation: 0, imageRotation: 0 },
            { id: "3", x: 794, y: 462, width: 233, height: 352, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 102, width: 233, height: 352, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 462, width: 233, height: 352, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-07",
        name: "PO 07 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 101, y: 244, width: 286, height: 428, rotation: 0, imageRotation: 0 },
            { id: "2", x: 395, y: 176, width: 188, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 395, y: 462, width: 188, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 741, y: 244, width: 286, height: 428, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 244, width: 286, height: 428, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-08",
        name: "PO 08 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 100, y: 100, width: 487, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 769, y: 176, width: 388, height: 565, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1164, y: 176, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1164, y: 367, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1164, y: 558, width: 125, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-09",
        name: "PO 09 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 78, y: 197, width: 342, height: 522, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 197, width: 169, height: 257, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 462, width: 169, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 605, y: 197, width: 341, height: 522, rotation: 0, imageRotation: 0 },
            { id: "5", x: 954, y: 197, width: 341, height: 522, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-10",
        name: "PO 10 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 78, y: 197, width: 342, height: 522, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 197, width: 342, height: 522, rotation: 0, imageRotation: 0 },
            { id: "3", x: 778, y: 197, width: 342, height: 522, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1128, y: 197, width: 169, height: 257, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1128, y: 462, width: 169, height: 257, rotation: 0, imageRotation: 0 }
        ],
    },

];

